import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "tab"]
  static values  = { active: { type: String, default: "a" } }

  connect() {
    this._apply(this.activeValue)
  }

  switch(event) {
    const period = event.currentTarget.dataset.period
    this.activeValue = period
    this._apply(period)
  }

  _apply(period) {
    this.panelTargets.forEach(p => {
      p.style.display = p.dataset.period === period ? "" : "none"
    })
    this.tabTargets.forEach(t => {
      t.classList.toggle("mk-compare-btn--active", t.dataset.period === period)
    })
  }
}
